export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuButton.vue?vue&type=template&id=9c908b96&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuButton.vue?vue&type=template&id=9c908b96&scoped=true&
// module id = 92
// module chunks = 0